import React, { useState} from 'react';
import './Recruit.css';
import Text from '../common/Text.js'


    const InputList = ({value: category, onValueChange})  => {
    const [inputs, setInputs] = useState(['']); //input 값

        const [jobType, setJobType] = useState(['']); // 채용유형
        const [responsibilities, setResponsibilities] = useState(['']); // 담당업무
        const [qualifications, setQualifications] = useState(['']); // 필수조건
        const [preferences, setPreferences] = useState(['']); //우대조건
        
    //추가 input 값 상태를 업데이트한다.
    const handleInputChange = (index, value) => {
        const newInputs = [...inputs];
        newInputs[index] = value;
        setInputs(newInputs);
    };

    //입력완료 버튼 클릭이벤트 (부모컨테이너에 값을 전달한다.)
    const handleButtonClick = () =>  {
            let inputValues
            if(category === 'type')
            {
                inputValues = getInputValues();
                onValueChange(inputValues, category);
            }
            else if(category === 'task')
            {
                inputValues = getInputValues();
                onValueChange(inputValues, category);
            }
            else if(category === 'required')
            {
                inputValues = getInputValues();
                onValueChange(inputValues, category);
            }
            else if(category === 'requiredDetail')
            {
                inputValues = getInputValues();
                onValueChange(inputValues, category);
            }
            else if(category === 'prefered')
            {
                inputValues = getInputValues();
                onValueChange(inputValues, category);
            }     
            else if(category === 'preferedDetail')
            {
                inputValues = getInputValues();
                onValueChange(inputValues, category);
            }

    }
    
    //input값들을 ';'를 포함한 하나의 문자열로 만든다.
    const getInputValues= ()=> {
            const filteredInputs = inputs.filter(input => input.trim() !== ''); 
            return filteredInputs.join(';'); 
    }

    //input 추가
    const addInput = () => {
        setInputs([...inputs, '']); 
    };

    //input 삭제
    const removeInput = (index) => {
        const newInputs = inputs.filter((_, i) => i !== index); 
        setInputs(newInputs);
    };

    return (
       <>
        <div style={{ display: 'flex', flexWrap: 'wrap', maxWidth: '1040px' }}>
            {inputs.map((input, index) => (
                <div className='div-wrapper' key={index} >
                    <input
                        type="text"
                        value={input}
                        onChange={(e) => handleInputChange(index, e.target.value)}
                        style={{ paddingRight: '40px', width: '200px' }} 
                    />
                    <button className='btnInputDel' onClick={() => removeInput(index)}>
                        <Text variant="px14R" >삭제</Text>
                        </button>
                </div>
            ))}
            <button className='btnInputAdd' onClick={addInput}>
            <Text variant="px14" >추가</Text>
            </button> 
        </div>

            {/* <div>
                <button className='btnInputSave' onClick={()=>handleButtonClick('type')} >
                <Text variant="px14" >입력완료</Text>
                </button>
            </div> */}

       </>
        
    );
};

export default InputList;
